/**
 * Descripción de una frase por estado — spec §6.3.
 *
 * Es lo que traduce un nombre de estado interno a algo que la estación
 * entiende. Se muestra bajo cada etapa en la línea de tiempo vertical y bajo
 * el estado actual en la horizontal.
 *
 * TODO: revisar con negocio. El spec lo clasifica como entregable de contenido
 * y esta versión está redactada, no validada. Un estado sin texto acá no rompe
 * nada: simplemente no muestra descripción.
 */
export const STATE_DESCRIPTIONS: Record<string, string> = {
  // Incidencias
  incidents_review_zone_leader:
    'Tu incidencia fue recibida y quedó en la fila de revisión del Jefe de Zona.',
  incidents_review_mantti: 'Mantenimiento/TI está catalogando el caso y definiendo la prioridad.',
  incidents_process: 'Un técnico fue asignado y está en camino o trabajando en sitio.',
  incidents_escalated_ti: 'El caso se escaló al equipo de TI porque depende de un sistema.',
  incidents_taskcompleted:
    'El técnico terminó — Mantenimiento/TI está validando la calidad del trabajo.',
  incidents_works_review_mantti:
    'Mantenimiento/TI está revisando en detalle los trabajos ejecutados.',
  incidents_closed: 'La incidencia quedó cerrada. Si el problema vuelve, repórtalo de nuevo.',

  // Órdenes de trabajo
  ot_start_date_review: 'Se está confirmando la fecha en que el proveedor puede empezar.',
  ot_future_tasks: 'El trabajo quedó programado para una fecha futura.',
  ot_assigned: 'La orden ya tiene proveedor asignado y está a la espera de ejecución.',
  ot_execution: 'El proveedor está ejecutando el trabajo en terreno.',
  ot_escalated_ti: 'La ejecución se escaló a TI porque depende de un sistema.',
  ot_review: 'El trabajo terminó y está en revisión antes de cerrarse.',
  ot_support_review: 'Soporte está revisando el trabajo ejecutado.',
  ot_budget_review: 'Se está revisando el presupuesto antes de autorizar el cierre.',
  ot_extension_review: 'El proveedor pidió una prórroga y está en evaluación.',
  ot_replacement_review: 'Se está gestionando un repuesto para poder terminar el trabajo.',
  ot_pre_closed: 'El trabajo quedó pre-cerrado, a la espera de las validaciones finales.',
  ot_logistics_rejected: 'La logística inversa fue rechazada y hay que corregirla.',
  ot_warehouse_confirm: 'Bodega tiene que confirmar la recepción de los materiales.',
  ot_preliminary_closed: 'La orden quedó cerrada de forma preliminar.',
  ot_closed_end: 'La orden está cerrada. Queda solo el trámite administrativo.',
  ot_payment_process: 'El pago al proveedor está en proceso.',
  ot_edp_confirmado: 'El pago al proveedor quedó confirmado.',
  ot_sent_sap: 'La orden se envió a SAP. El proceso terminó.',
}

export const describeState = (code: string | null | undefined): string =>
  (code && STATE_DESCRIPTIONS[code]) || ''
